import { useState, useEffect, useCallback } from "react";
import { Api } from "../request/api/api";
import { CreateFighterTypeDto, FighterTypeDict, UpdateFighterTypeDto } from "../model/Dto/Dict/FighterType";

export function useFighterTypesDict(filterValue: string) {
    const [fighterTypes, setFighterTypes] = useState<FighterTypeDict[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchFighterTypes = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const onlyCommon = filterValue === "common";
            const factionId = filterValue !== "" && filterValue !== "common" ? filterValue : undefined;
            const result = await Api.dict.getAllFighterTypesDict(factionId, onlyCommon);
            setFighterTypes(result);
        } catch {
            setError("Ошибка загрузки типов бойцов");
        } finally {
            setLoading(false);
        }
    }, [filterValue]);

    const createFighterType = useCallback(async (data: CreateFighterTypeDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createFighterType(data);
            if (result) {
                await fetchFighterTypes();
                return true;
            }
            setError("Ошибка создания типа бойца");
            return false;
        } catch {
            setError("Ошибка создания типа бойца");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchFighterTypes]);

    const updateFighterType = useCallback(async (id: string, data: UpdateFighterTypeDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateFighterType(id, data);
            if (result) {
                await fetchFighterTypes();
                return true;
            }
            setError("Ошибка обновления типа бойца");
            return false;
        } catch {
            setError("Ошибка обновления типа бойца");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchFighterTypes]);

    const deleteFighterType = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteFighterType(id);
            if (result) {
                await fetchFighterTypes();
                return true;
            }
            setError("Ошибка удаления типа бойца");
            return false;
        } catch {
            setError("Ошибка удаления типа бойца");
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchFighterTypes]);

    useEffect(() => {
        fetchFighterTypes();
    }, [fetchFighterTypes]);

    return { fighterTypes, loading, error, createFighterType, updateFighterType, deleteFighterType };
}
